module.exports = __webpack_public_path__ + "static/img/06_2.80f0b79.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/activity20250403/06_2.jpg
// module id = V/Qr
// module chunks = 0